import { Box } from "@mui/material";

export default function Navbar() {
  return <Box width="100%" py={1.5} sx={{ position: "fixed", top: 0, zIndex: 1000 }} bgcolor="#f2f3f5">
    <Box width="90%" m="auto">
      <img src="logos/logo+wordmark.svg" height={32} alt="logo" />
    </Box>
  </Box>
}